import { render, staticRenderFns } from "./PhotoStation.vue?vue&type=template&id=b8cdc038&"
import script from "./PhotoStation.vue?vue&type=script&lang=js&"
export * from "./PhotoStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports